// @ts-ignore
import monotonicTimestamp from 'monotonic-timestamp';
import { Dateable } from './types';

const withMonotonicTimestamp = (fn: (mts: Dateable) => void) => {
  return fn(monotonicTimestamp());
};

export default withMonotonicTimestamp;
